import React from 'react';
import { Textarea as TextareaNew } from './Textarea';
import { convertOldTextareaProps } from './converter.old';
import type { OldTextareaProps } from './converter.old';

export type TextareaProps = OldTextareaProps;

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>((props, ref) => (
  <TextareaNew {...convertOldTextareaProps(props)} ref={ref} />
));
